/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/window.d.ts" />

namespace Application.Services {
    'use strict';

    export interface IBlockConnection {
        streamPipeStatus: boolean;
        origBlockId?: number
        destBlockId?: number
    }

    /**
     * BlockConnectionNodesService
     */
    export class BlockConnectionNodesService {

        public static $name: string = 'blockConnectionNodesService';
        public static $inject: string[] = ['$http', 'backendService', '$q', '$timeout'];


        private backendBaseUrl: string = window.backendUrl;
        private servicePath: string = '';
        private blockConnectionNodesBackendUrl: string = this.backendBaseUrl + this.servicePath + 'blockConnectionNodesRef/';



        constructor(private $http: ng.IHttpService,
                    private backendService: BackendService) {
        }

        public getBlockConnectionNodes(href: String): ng.IPromise<IBlockConnection[]> {
            return this.backendService.get(this.blockConnectionNodesBackendUrl + href, false).then(
                (response: ng.IHttpPromiseCallbackArg<IBlockConnection[]>) => {
                return response.data;

            });


        }
    }
}